// frontend/src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { DEFAULT_LANGUAGE } from "@/locales/locales";
import en from "@/locales/en/translation.json";
import de from "@/locales/de/translation.json";
import privacyEn from "@/locales/en/privacy.json";
import termsEn from "@/locales/en/terms.json";
import privacyDe from "@/locales/de/privacy.json";
import termsDe from "@/locales/de/terms.json";


// Key used in localStorage for the language preference
export const LOCAL_STORAGE_LANG_KEY = "lang";

// Build-time resources => no network race on first paint
const resources = {
  en: {
    translation: en,
    privacy: privacyEn,
    terms: termsEn
  },
  de: {
    translation: de,
    privacy: privacyDe,
    terms: termsDe
  }
};

// We keep detector enabled (useful for logged-out users), but
// our LanguageGate will override language once the user profile is known.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    // Multiple namespaces for different areas of the app
    // (helps keep things organized and smaller to load)
    ns: ["translation", "privacy", "terms"],
    defaultNS: "translation",
    fallbackNS: "translation",
    supportedLngs: ["en", "de"],
    // Detector order: prefer localStorage, then browser
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: LOCAL_STORAGE_LANG_KEY
    },
    interpolation: {
      escapeValue: false
    },
    // Avoid returning null or undefined which can render oddly
    returnNull: false,
    returnEmptyString: true
  });

export default i18n;